import * as React from 'react';
import { Transform, useTransform } from '../utility/useTransform';
import { utilityClasses, createClassWithSuffix } from '../utility';
import { LayerStyleProps, useLayerCounterStyle } from './useLayerCounterStyle';

export interface LayerCounterProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, 'style'> {
	transform?: Transform;
	position?: 'bottom-left' | 'bottom-right' | 'top-left' | 'top-right';
	style?: LayerStyleProps;
}

export function LayerCounter({ className, transform, position, style = {}, ...props }: LayerCounterProps): JSX.Element {
	const transformProps = useTransform(transform);
	const customStyle = useLayerCounterStyle(style);
	const classes = [className, utilityClasses.layersCounter, position && createClassWithSuffix(utilityClasses.position, position)].filter(Boolean).join(' ');

	return <span className={classes} style={customStyle} {...transformProps} {...props} />;
}
